import React, { useState, useEffect } from "react";
import { getUserById } from "../../../services/users";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CancellationModal from "../CancellationModal";
import { DarkNavButton } from "../../../components/Buttons";
import { ClipLoader } from "react-spinners";
import usePrivilege from "../../../hooks/usePrivilege";
const PropertyDetailsTab = ({ sale, property, onSaleUpdate, activeTab, customerId }) => {
  const { hasPrivilege } = usePrivilege();
  const [loading, setLoading] = useState(false);
  const [secondaryUserDetails, setSecondaryUserDetails] = useState([]);
  const [isCancellationModalOpen, setIsCancellationModalOpen] = useState(false);

  useEffect(() => {
    const fetchSecondaryUsers = async () => {
      if (sale?.secondaryUsersId && sale.secondaryUsersId.length > 0) {
        try {
          setLoading(true);
          const userPromises = sale.secondaryUsersId.map(async (userId) => {
            const response = await getUserById(userId);
            return response;
          });
          const userDetails = await Promise.all(userPromises);
          setSecondaryUserDetails(userDetails);
        } catch (error) {
          console.error("Failed to fetch secondary users:", error);
          toast.error("Failed to fetch secondary users");
        } finally {
          setLoading(false);
        }
      } else {
        setSecondaryUserDetails([]);
      }
    };
    fetchSecondaryUsers();
  }, [sale]);

  // Legacy handleInputChange + handlePhoneChange removed — the new Form/Field
  // wrapper drives the secondary-user form via react-hook-form + yup.

  const handleCancelSaleClick = () => {
    setIsCancellationModalOpen(true);
  };
  const handleSaleUpdate = (state) => {
    if (onSaleUpdate) {
      onSaleUpdate(state);
    }
  };
  const closeCancellationModal = (state) => {
    setIsCancellationModalOpen(false);
    if (state) {
      handleSaleUpdate(state);
    }
  };
  return (
    <>

      {sale && (
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-md font-semibold">Sales Details</h2>
            {sale?.cancellationStatus == null && hasPrivilege("canEdit") && (
              <DarkNavButton className={"w-32"} onClick={handleCancelSaleClick}>
                Cancel Sale
              </DarkNavButton>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="">
              <p className="text-sm font-normal text-slate-500">Sale Date</p>
              <p className="font-normal">{sale?.saleDate}</p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-slate-500">
                Payment Option
              </p>
              <p className="font-normal">{sale?.paymentOption}</p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-slate-500">
                Agreement Value
              </p>
              <p className="font-normal">{sale?.basePrice}</p>
            </div>
            {/* <div className="">
              <p className="text-sm font-normal text-slate-500">Commission</p>
              <p className="font-normal">{sale?.commission || "-"}</p>
            </div> */}
            <div className="">
              <p className="text-sm font-normal text-slate-500">GST</p>
              <p className="font-normal">{sale?.gst}</p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-slate-500">Stamp Duty</p>
              <p className="font-normal">{sale?.stampDuty}</p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-slate-500">
                Registration Price
              </p>
              <p className="font-normal">{sale?.registrationPrice}</p>
            </div>
            {sale?.ocDate && (
              <div className="">
                <p className="text-sm font-normal text-slate-500">OC Date</p>
                <p className="font-normal">{sale?.ocDate}</p>
              </div>
            )}
            <div className="">
              <p className="text-sm font-normal text-slate-500">
                Customer Bank Email
              </p>
              <p className="font-normal">{sale?.customerBankEmail}</p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-slate-500">
                Cancellation Status
              </p>
              <p className="font-normal">
                {sale?.cancellationStatus ?? "Not Cancelled"}
              </p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-slate-500">
                {sale?.agent?.ownerName
                  ? "Channel Partner"
                  : sale?.source === "PRE_SALES"
                  ? "PRE_SALE SOURCE"
                  : "Source"}
              </p>
              <p className="font-normal">
                {sale?.agent?.ownerName
                  ? sale.agent.ownerName
                  : sale?.source === "PRE_SALES"
                  ? sale?.presales?.name || "NA"
                  : sale?.source
                  ? sale.source
                  : "NA"}
              </p>
            </div>
          </div>
        </div>
      )}
      {property && (
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-md font-semibold">Property Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">Property No</p>
              <p className="font-normal">{property?.propertyNo}</p>
            </div>
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">Building</p>
              <p className="font-normal">{property?.buildingNo}</p>
            </div>
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">Project Name</p>
              <p className="font-normal">{property?.project?.projectName}</p>
            </div>

            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">
                Property Type
              </p>
              <p className="font-normal">{property?.propertyType}</p>
            </div>
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">Sale Type</p>
              <p className="font-normal">{property?.propertySaleType}</p>
            </div>
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">
                Property State
              </p>
              <p className="font-normal">{property?.propertyState}</p>
            </div>
          </div>
        </div>
      )}
      {sale?.user && (
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-md font-semibold">User Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">Name</p>
              <p className="font-normal">
                {sale?.user?.title} {sale?.user?.firstName}{" "}
                {sale?.user?.lastName}
              </p>
            </div>
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">Email ID</p>
              <p className="font-normal">{sale?.user?.emailId}</p>
            </div>
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">
                Mobile (Calling)
              </p>
              <p className="font-normal">{sale?.user?.mobileNoCalling}</p>
            </div>
            <div className="p-3">
              <p className="text-sm font-normal text-slate-500">
                Mobile (Whatsapp)
              </p>
              <p className="font-normal">{sale?.user?.mobileNoWa}</p>
            </div>
            <div className="p-3 col-span-full">
              <p className="text-sm font-normal text-slate-500">Address</p>
              <p className="font-normal">
                {
                  [
                    sale?.user?.address?.buildingNo,
                    sale?.user?.address?.streetName1,
                    sale?.user?.address?.streetName2,
                    sale?.user?.address?.city,
                    sale?.user?.address?.district,
                    sale?.user?.address?.state,
                    sale?.user?.address?.country,
                  ]
                    .filter(Boolean)
                    .join(", ") +
                  (sale?.user?.address?.pinCode ? ` - ${sale?.user?.address?.pinCode}` : "")
                }
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Secondary User Details Section — co-applicants are now added at Create Sale time,
          so this view is read-only. */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-md font-semibold">Secondary User Details</h2>
        </div>
        {loading ? (
          <div className="flex justify-center">
            <ClipLoader color="#000" loading={loading} size={20} />
          </div>
        ) : secondaryUserDetails && secondaryUserDetails.length > 0 ? (
          <div className="space-y-4">
            {secondaryUserDetails.map((user) => {  // Map directly over the user
              return (
                <div
                  key={user.userId}
                  className="border p-4 rounded-md border-gray-200"
                >
                  <div className="grid grid-rows md:grid-cols-2 gap-4">
                    <div className="">
                      <p className="text-sm font-normal text-slate-500">Name</p>
                      <p className="font-normal">
                        {user?.title} {user?.firstName} {user?.lastName}
                      </p>
                    </div>
                    <div className="">
                      <p className="text-sm font-normal text-slate-500">Email ID</p>
                      <p className="font-normal">{user?.emailId}</p>
                    </div>
                    <div className="">
                      <p className="text-sm font-normal text-slate-500">
                        Mobile (Calling)
                      </p>
                      <p className="font-normal">{user?.mobileNoCalling}</p>
                    </div>
                    <div className="">
                      <p className="text-sm font-normal text-slate-500">
                        Mobile (Whatsapp)
                      </p>
                      <p className="font-normal">{user?.mobileNoWa}</p>
                    </div>
                    <div className="md:col-span-2">
                      <p className="text-sm font-normal text-slate-500">
                        Address
                      </p>
                      <p className="font-normal">
                        {user?.address?.buildingNo}, {user?.address?.streetName1}
                        {user?.address?.streetName2 &&
                          `, ${user?.address?.streetName2}`}, {user?.address?.city},{" "}
                        {user?.address?.district}, {user?.address?.state},{" "}
                        {user?.address?.country} - {user?.address?.pinCode}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-4">
            <p className="text-gray-500">No secondary users added.</p>
          </div>
        )}
      </div>

      {sale && (
        <CancellationModal
          isOpen={isCancellationModalOpen}
          onClose={closeCancellationModal}
          propertyId={property?.propertyId}
          customerSaleId={sale?.customerSalesId}
          customerId={customerId}
        />
      )}
    </>
  );
};
export default PropertyDetailsTab;